function ButtonFunction({
  children, disabled = false,
  buttonFunction = emptyFunction,
  buttonArguments,
  buttonClass = "button"
}) {
  return (
    <button disabled={disabled} className={buttonClass} onClick={() => buttonFunction(buttonArguments)}>
        {children}
    </button>
  )
}

const emptyFunction = () => {}

export default ButtonFunction